export const SEARCH_CONFIG = {
    MIN_SEARCH_LENGTH: 1,
};